<template>
    <b-modal ref="autoresponderEditor" @hide="$emit('hide')" @ok="doSave"
        size="xl" v-model="show" no-close-on-backdrop scrollable button-size="sm" :ok-disabled="$v.$invalid">
        <template v-slot:modal-title>{{$t('autoresponderEditor.title', { name: autoresponder.name})}}</template>
        <b-container fluid class="autoresponderEditor">
            <b-row>
                <b-col cols="6">
                    <b-form-group :label="$t('autoresponderEditor.name')" size="sm">
                        <b-input v-model="autoresponder.name" :state="!$v.autoresponder.name.$invalid" size="sm"
                                :placeholder="$t('autoresponderEditor.namePlaceholder')"></b-input>
                        <input-feedback :validation="this.$v.autoresponder.name"></input-feedback>
                    </b-form-group>
                </b-col>
                <b-col cols="6">
                    <b-form-group :label="$t('autoresponderEditor.subject')">
                        <b-container fluid>
                            <b-row>
                                <b-col cols="3"><b-select size="sm" :options="subjectOptions" v-model="subjectMode"
                                    ></b-select>
                                </b-col>
                                <b-col>
                                    <b-input size="sm" v-model="autoresponder.subject"
                                            v-show="subjectMode === 'subject'"
                                        :placeholder="$t('autoresponderEditor.subjectPlaceholder')"></b-input>
                                    <b-input size="sm" v-model="autoresponder.subjectprefix"
                                            v-show="subjectMode === 'prefix'"
                                            :placeholder="$t('autoresponderEditor.subjectPrefixPlaceholder')"></b-input>
                                    <b-input size="sm" readonly
                                            :value="$store.state.settings.defaultautorespondersubjectprefix"
                                            v-show="subjectMode === 'defaultprefix'"></b-input>
                                </b-col>
                            </b-row>
                        </b-container>
                    </b-form-group>
                </b-col>
                <b-col cols="12">
                    <b-form-group :label="$t('autoresponderEditor.text')">
                        <b-textarea v-model="autoresponder.text" :state="!$v.autoresponder.text.$invalid" size="sm"
                                :placeholder="$t('autoresponderEditor.textPlaceholder')"></b-textarea>
                        <input-feedback :validation="this.$v.autoresponder.text"></input-feedback>
                    </b-form-group>
                </b-col>

                <b-col cols="6">
                    <b-form-group :label="$t('autoresponderEditor.checkLog')"
                            :state="!$v.autoresponder.checklog.$invalid">
                        <b-input-group :append="$t('autoresponderEditor.checkLogSuffix')" size="sm">
                            <b-input type="number" v-model.number="autoresponder.checklog" min="0"
                                    :placeholder="$t('autoresponderEditor.checkLogPlaceholder')"
                                    :state="!$v.autoresponder.checklog.$invalid"></b-input>
                        </b-input-group>
                        <input-feedback :validation="$v.autoresponder.checklog"></input-feedback>
                    </b-form-group>
                </b-col>
                <b-col cols="6">
                    <b-form-group :label="$t('autoresponderEditor.respondAfter')">
                        <b-input type="number" v-model.number="autoresponder.respondafter" min="0"
                                :placeholder="$t('autoresponderEditor.respondAfterPlaceholder')"
                                :state="!$v.autoresponder.respondafter.$invalid" size="sm"></b-input>
                        <input-feedback :validation="$v.autoresponder.respondafter"></input-feedback>
                    </b-form-group>
                </b-col>
                <b-col cols="6">
                    <b-form-group :label="$t('autoresponderEditor.sender')">
                        <b-input v-model="autoresponder.sender"
                                :placeholder="$t('autoresponderEditor.senderPlaceholder')"
                                :state="!$v.autoresponder.sender.$invalid" size="sm"></b-input>
                        <input-feedback :validation="this.$v.autoresponder.sender"></input-feedback>
                    </b-form-group>
                </b-col>
                <b-col cols="6">
                    <b-form-group :label="$t('autoresponderEditor.replyto')">
                        <b-input v-model="autoresponder.replyto"
                                :placeholder="$t('autoresponderEditor.replytoPlaceholder')"
                                :state="!$v.autoresponder.replyto.$invalid" size="sm"></b-input>
                        <input-feedback :validation="this.$v.autoresponder.replyto"></input-feedback>
                    </b-form-group>
                </b-col>
                <b-col cols="6">
                    <b-form-group :label="$t('autoresponderEditor.copyto')">
                        <recipient-editor border v-model="autoresponder.copyto"
                                :placeholder="$t('autoresponderEditor.copytoPlaceholder')"></recipient-editor>
                    </b-form-group>
                </b-col>
                <b-col cols="6">
                    <b-form-group :label="$t('autoresponderEditor.to')">
                        <recipient-editor border v-model="autoresponder.to"
                                :placeholder="$t('autoresponderEditor.toPlaceholder')"></recipient-editor>
                    </b-form-group>
                </b-col>
                <b-col cols="6">
                    <b-form-group>
                        <b-checkbox v-model="sendToOriginalSender">{{$t('autoresponderEditor.sendToOriginalSender')
                            }}</b-checkbox>
                    </b-form-group>
                </b-col>

                <b-col cols="6">
                    <b-form-group :description="autoresponder.keep?'':$t('autoresponderEditor.keepWarning')">
                        <b-checkbox v-model="autoresponder.keep">{{$t('autoresponderEditor.keep')}}</b-checkbox>
                    </b-form-group>
                </b-col>
            </b-row>
        </b-container>
    </b-modal>
</template>

<script>
import { required, minValue } from 'vuelidate/lib/validators';
import RecipientEditor from './recipientEditor';
import InputFeedback from '@/components/inputFeedback';

export default {
  name: 'autoresponderEditor',
  components: { RecipientEditor, InputFeedback },
  data: function() {
    return {
      autoresponder: {},
      sendToOriginalSender: true,
      subjectMode: 'prefix',
      show: false
    };
  },
  props: {
    value: Object
  },
  validations: {
    autoresponder: {
      name: { required },
      text: { required },
      checklog: { min: minValue(0), required },
      respondafter: { min: minValue(0), required },
      sender: { },
      replyto: { }
    }
  },
  watch: {
    value(newVal) {
      this.autoresponder = {};
      if (newVal) {
        this.loadData(newVal);
        if (newVal.id) {
          this.show = true;
        }
      } else {
        this.show = false;
      }
    }
  },
  methods: {
    doSave($evt) {
      if (this.sendToOriginalSender) {
        this.autoresponder.to.splice(0, 0, '*');
      }
      switch (this.subjectMode) {
        case 'subject':
          this.autoresponder.subjectprefix = '*';
          break;
        case 'prefix':
          this.autoresponder.subject = '';
          break;
        case 'defaultprefix':
          this.autoresponder.subject = '';
          this.autoresponder.subjectprefix = '*';
          break;
      }
      this.$emit('input', this.autoresponder);
    },
    loadData(value) {
      this.autoresponder = Object.assign({}, value);
      const ind = this.autoresponder.to.indexOf('*');
      this.sendToOriginalSender = (ind !== -1);
      if (ind !== -1) {
        this.autoresponder.to.splice(ind, 1);
      }
      if (this.autoresponder.subject !== '') {
        this.subjectMode = 'subject';
      } else if (this.autoresponder.subjectprefix === '*') {
        this.subjectMode = 'defaultprefix';
        this.autoresponder.subjectprefix = '';
      } else {
        this.subjectMode = 'prefix';
      }
    }
  },
  computed: {
    subjectOptions() {
      return [
        { text: this.$t('autoresponderEditor.subjectModeDefaultPrefix'), value: 'defaultprefix' },
        { text: this.$t('autoresponderEditor.subjectModePrefix'), value: 'prefix' },
        { text: this.$t('autoresponderEditor.subjectModeSubject'), value: 'subject' }
      ];
    }
  }
};
</script>

<style scoped lang="scss">

    .autoresponderEditor {
        font-size: 0.875rem;
    }
    .container-fluid {
        padding-left: 0;
        padding-right: 0;
    }
</style>
